;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.dashboard')
    .service('AggregationService', AggregationService)

  AggregationService.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]

  function AggregationService (// Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    var self = this

    _.extend(self, {
      // Public Attributes
      // Public Method
      aggregate: aggregate,
      simpleFinancial: simpleFinancial
    })

    /**
     * Return aggregation array
     * @param groupBy String
     * @param type String
     * @param concern String
     * @param configuration Object
     */
    function aggregate (groupBy, type, concern, configuration) {
      var operations
      switch (concern) {
        case 'invoice':
        case 'quote':
        case 'creditnote':
        case 'deposit':
          operations = buildInvoiceQuoteCreditNote(groupBy, type, concern, configuration)
          break
        case 'product':
          operations = buildProduct(groupBy, type)
          break
        case 'balance':
          operations = buildBalance(groupBy)
          break
      }
      return operations
    }

    function buildInvoiceQuoteCreditNote (groupBy, type, concern, configuration) {
      var lookup
      var sort
      var project = {
        $project: {
          _id: 1,
          total: 1
        }
      }
      var aggregation = []
      var group = {
        $group: {
          _id: '$' + groupBy
        }
      }
      switch (groupBy) {
        case 'client':
          lookup = {
            $lookup: {
              from: 'crm.entities',
              localField: '_id',
              foreignField: '_id',
              as: 'client'
            }
          }
          project.$project._id = {
            $arrayElemAt: [
              '$client.label',
              0
            ]
          }
          break
        case 'status':
          break
        case 'tags':
          aggregation.unshift({
            $unwind: {
              path: '$tags',
              preserveNullAndEmptyArrays: true
            }
          })
          lookup = {
            $lookup: {
              from: 'kilo.tags',
              localField: '_id',
              foreignField: '_id',
              as: 'tags'
            }
          }
          project.$project._id = {
            $arrayElemAt: [
              '$tags.label',
              0
            ]
          }
          break
        case 'date':
        case 'dueDate':
          var id = {}
          var proj = {}
          switch (configuration) {
            case 'weekly':
              id = {
                year: {$year: '$' + groupBy},
                week: {$week: '$' + groupBy}
              }
              proj = {
                $concat: [
                  'Semaine ',
                  {
                    $substr: ['$_id.week', 0, -1]
                  },
                  ' année ',
                  {
                    $substr: ['$_id.year', 0, -1]
                  }
                ]
              }
              sort = {
                $sort: {
                  '_id.year': 1,
                  '_id.week': 1
                }
              }
              break
            case 'monthly':
              id = {
                year: {$year: '$' + groupBy},
                month: {$month: '$' + groupBy}
              }
              proj = {
                $concat: [
                  {
                    $substr: ['$_id.month', 0, -1]
                  },
                  '/',
                  {
                    $substr: ['$_id.year', 0, -1]
                  }
                ]
              }
              sort = {
                $sort: {
                  '_id.year': 1,
                  '_id.month': 1
                }
              }
              break
            case 'quarterly':
              id = {
                quarter: '$quarter',
                year: '$year'
              }
              aggregation.push({
                $project: {
                  total: 1,
                  computed: 1,
                  year: {
                    $year: '$' + groupBy
                  },
                  quarter: {
                    $substr: [
                      {
                        $add: [
                          {
                            $divide: [
                              {
                                $subtract: [
                                  {
                                    $month: '$' + groupBy
                                  },
                                  1
                                ]
                              },
                              3
                            ]
                          },
                          1
                        ]
                      },
                      0,
                      1
                    ]
                  }
                }
              })
              proj = {
                $concat: [
                  'Trimestre ',
                  {
                    $substr: [
                      '$_id.quarter',
                      0,
                      -1
                    ]
                  },
                  ' ',
                  {
                    $substr: [
                      '$_id.year',
                      0,
                      -1
                    ]
                  }
                ]
              }
              sort = {
                $sort: {
                  '_id.year': 1,
                  '_id.quarter': 1
                }
              }

              break
            case 'yearly':
              id = {$year: '$' + groupBy}
              proj = {_id: 1}
              sort = {
                $sort: {
                  _id: 1
                }
              }
              break
          }

          group = {
            $group: {
              _id: id
            }
          }
          project.$project._id = proj
          aggregation.unshift({
            $unwind: '$' + groupBy
          })
          break
        case 'referers':
          aggregation.unshift({
            $unwind: {
              path: '$referers',
              preserveNullAndEmptyArrays: true
            }
          })
          aggregation.unshift()
          lookup = {
            $lookup: {
              from: 'zenlabs.users',
              localField: '_id',
              foreignField: '_id',
              as: '_id'
            }
          }
          project.$project._id = {
            $concat: [
              {$arrayElemAt: ['$_id.firstname', 0]},
              ' ',
              {$arrayElemAt: ['$_id.lastname', 0]}
            ]
          }
          break
      }
      if (type === 'financial') {
        group.$group.total = {$sum: '$computed.fullDiscountedTotal'}
      } else {
        group.$group.total = {$sum: 1}
      }
      aggregation.push(group)
      if (lookup) {
        aggregation.push(lookup)
      }
      if (sort) {
        aggregation.push(sort)
      } else {
        aggregation.push({
          $sort: {
            total: -1
          }
        })
      }
      aggregation.push(project)
      return aggregation
    }

    function buildProduct (groupBy, type) {
      var lookup
      var project = {
        $project: {
          _id: 1,
          total: 1
        }
      }
      var aggregation = []
      var group = {
        $group: {
          _id: '$' + groupBy
        }
      }
      switch (groupBy) {
        case 'category':
          aggregation.unshift({
            $unwind: {
              path: '$tags',
              preserveNullAndEmptyArrays: true
            }
          })
          break
        case 'tags':
          aggregation.unshift({
            $unwind: {
              path: '$tags',
              preserveNullAndEmptyArrays: true
            }
          })
          lookup = {
            $lookup: {
              from: 'kilo.tags',
              localField: '_id',
              foreignField: '_id',
              as: 'tags'
            }
          }
          project.$project._id = {
            $arrayElemAt: [
              '$tags.label',
              0
            ]
          }
          aggregation.push(lookup)
          break
      }
      if (type === 'financial') {
        group.$group.total = {$sum: '$total'}
      } else {
        group.$group.total = {$sum: 1}
      }
      aggregation.push(group)
      if (project) {
        aggregation.push(project)
      }
      return aggregation
    }

    function buildBalance () {
      var aggregation = []
      aggregation.push({
        $group: {
          _id: '$client',
          total: {
            $sum: '$value'
          }
        }
      })
      aggregation.push({
        $lookup: {
          from: 'crm.entities',
          localField: '_id',
          foreignField: '_id',
          as: 'client'
        }
      })
      aggregation.push({
        $sort: {
          total: -1
        }
      })
      aggregation.push({
        $project: {
          _id: {
            $arrayElemAt: [
              '$client.label',
              0
            ]
          },
          total: 1
        }
      })
      return aggregation
    }

    function simpleFinancial (concern) {
      var group
      switch (concern) {
        case 'invoice':
        case 'quote':
        case 'deposit':
          group = {
            $group: {
              _id: '',
              total: {
                $sum: '$computed.fullDiscountedTotal'
              },
              totalNumber: {
                $sum: 1
              }
            }
          }
          break
        case 'creditnote':
          group = {
            $group: {
              _id: '',
              total: {
                $sum: '$total'
              },
              totalNumber: {
                $sum: 1
              }
            }
          }
          break
        case 'balance':
          group = {
            $group: {
              _id: '',
              total: {
                $sum: '$value'
              },
              totalNumber: {
                $sum: 1
              }
            }
          }
          break
      }
      return [group]
    }
  }
})(window.angular, window._)
